import { useState, useRef, useEffect } from "react";
import { burgerIcon, closeIcon } from "../../assets/icons";
import ItemContainer from "./ItemContainer/ItemContainer";
import styles from "./menu.module.css";

export default function Menu() {
  const [isVisible, setIsVisible] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleOnClick = () => {
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsVisible(false);
      }
    };

    // Only add the event listener when the menu is visible
    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);

  return (
    <div className={styles.menu} ref={menuRef}>
      <button onClick={handleOnClick} className={styles.menuButton}>
        {isVisible ? closeIcon : burgerIcon}<span>Menu</span>
      </button>
      <ItemContainer isVisible={isVisible} handleOnClick={handleOnClick}/>
    </div>
  );
}
